import { useState } from 'react';

import { usePlatformShare } from 'core';
import { ShareModal } from 'core/Components';
import { ButtonMantine, Group, ImageMantine } from 'ui';
import { IconShare } from 'ui/Icons';

const HeaderImage = () => {
  const { platformShare } = usePlatformShare();
  const shareLink = window.location.href;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  return (
    <>
      <Group w="100%" justify="space-between">
        <ImageMantine
          src={
            'https://s3.us-east-1.amazonaws.com/com.givebacks.public/icons/givebacks/gb-blue-background-orange-text.png'
          }
          w={48}
          h={48}
          radius={12}
        />
        <ButtonMantine
          variant="white"
          color="gray"
          size="sm"
          leftSection={<IconShare />}
          onClick={() =>
            void platformShare(
              {
                share_options: { url: shareLink },
              },
              () => setIsShareModalOpen(true)
            )
          }
        >
          Share
        </ButtonMantine>
      </Group>
      <ShareModal
        opened={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        link={shareLink}
        type="campaign"
        causeName={'The Gift It Forward Campaign'}
      />
    </>
  );
};

export { HeaderImage };
